export const PLATFORM_NAME = "Culqi360";
